// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__mDcrc","img":"Banner_img__3ZiiI","note":"Banner_note__ELyOP","text-right-to-left":"Banner_text-right-to-left__wQmKR"};